function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{isolation:isolate;}.cls-11{fill:#051c41;}.cls-12{fill:#b9caef;}.cls-13{fill:#354079;}.cls-14{fill:#639ec7;}.cls-15,.cls-23{fill:#fff;}.cls-15{mix-blend-mode:soft-light;}.cls-16{fill:#02cc9a;}.cls-17{fill:#414c96;}.cls-18{fill:#3f7fb4;}.cls-19{fill:#1d2350;}.cls-20{fill:#d1cae4;}.cls-21{fill:#c2b8db;}.cls-22{fill:#3f3574;}.cls-24{fill:#ffa412;}.cls-25{fill:#17005a;}.cls-26{fill:#35488b;}.cls-27{fill:#f5b691;}.cls-28{fill:#7561ab;}.cls-29{fill:#ffb93e;}.cls-30{mask:url(#mask);}.cls-31{fill:#f2987c;}.cls-32{mask:url(#mask-2);}.cls-33{mask:url(#mask-3);}.cls-34{fill:#db8200;}.cls-35{fill:#2c3a64;}.cls-36{fill:none;}.cls-37{mask:url(#mask-4);}.cls-38{mask:url(#mask-5);}.cls-39{mask:url(#mask-6);}.cls-40{fill:#ef805c;}.cls-41{mask:url(#mask-7);}.cls-42{fill:#f2957a;}.cls-43{mask:url(#mask-8);}.cls-44{fill:#291857;}.cls-45{mask:url(#mask-9);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 211.82,
  y1: 215.72,
  x2: 227.38,
  y2: 215.72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 138.73,
  y1: 163.23,
  x2: 139.36,
  y2: 143.02,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 123.91,
  y1: 196.16,
  x2: 130.99,
  y2: 217.23,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 107.63,
  y1: 177.63,
  x2: 118.18,
  y2: 230.38,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 104.44,
  y1: 276.07,
  x2: 72.57,
  y2: 297.4,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 181.23,
  y1: 150.53,
  x2: 182.02,
  y2: 166.01,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 175.83,
  y1: 146.41,
  x2: 172.09,
  y2: 177.74,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 191.4,
  y1: 162.88,
  x2: 187.56,
  y2: 132.84,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 167.22,
  y1: 145.52,
  x2: 166.79,
  y2: 139.07,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask",
  x: 211.82,
  y: 206.64,
  width: 15.55,
  height: 18.17,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M216,209.73c-.93-1-1.73-2.14-2.71-3.09a30.6,30.6,0,0,1-1.42,6.18c.06.19.12.38.19.57a23.34,23.34,0,0,0,2.15,4.58,5.14,5.14,0,0,0,1.18,1.44,1.94,1.94,0,0,0,1.77.35,29.81,29.81,0,0,0-1.2-4.91,23.14,23.14,0,0,0,4.56,5.76,4.9,4.9,0,0,0,.32,1.09,4.62,4.62,0,0,0,2.18,2.16,10.19,10.19,0,0,0,3,.9,1.1,1.1,0,0,0,.8-.06,1.13,1.13,0,0,0,.39-.77,14.67,14.67,0,0,0,.22-3.31,46.67,46.67,0,0,0-2.8-6.6A13.77,13.77,0,0,1,216,209.73Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  x: 134.98,
  y: 141.35,
  width: 7.7,
  height: 25.54,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M142.07,160.7l.05.05c-.09.65-.19,1.31-.3,2-2.34,1.28-4.63,2.66-6.84,4.17a201.64,201.64,0,0,0,5.11-25.18c.53-.1,1.06-.22,1.58-.36a61.69,61.69,0,0,1,.45,19.32Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  x: 118.3,
  y: 194,
  width: 14.5,
  height: 30.89,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M132.79,207.82c-.53,5.69-1.13,11.37-1.71,17.07a232.08,232.08,0,0,1-12.43-29.62,8.26,8.26,0,0,1-.35-1.27l1.29,1.27C123.93,199.51,128.28,203.77,132.79,207.82Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  x: 96.64,
  y: 172.68,
  width: 34.44,
  height: 76.53,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M118.3,194,96.78,172.68s-3.52,53.4,24.6,72.6l.4-.2a4,4,0,0,1,.16.57,36.93,36.93,0,0,0,6.88,3.56c.37-4.9.81-9.8,1.29-14.71.31-3.21.64-6.41,1-9.61-1.27-2.52-2.5-5.07-3.67-7.64h0a231.18,231.18,0,0,1-8.76-22A8.26,8.26,0,0,1,118.3,194Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-5",
  x: 76.11,
  y: 280.68,
  width: 42.86,
  height: 13.22,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M76.11,280.68c.28.5.58,1,.88,1.49a34.17,34.17,0,0,0,12.09,11.74A90.34,90.34,0,0,0,119,280.68Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  x: 178.15,
  y: 150.17,
  width: 6.94,
  height: 14.34,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M185.09,160a13.33,13.33,0,0,1-4.78-9.79,4.29,4.29,0,0,1-1.95,0,57.49,57.49,0,0,0,.58,14.35l1.61-1.08A53.52,53.52,0,0,0,185.09,160Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-7",
  x: 168.34,
  y: 148.41,
  width: 10.6,
  height: 21.15,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M178.36,150.17a10.14,10.14,0,0,1-2-.66,9.78,9.78,0,0,0-3.77-1.1,46,46,0,0,0-4.28,19.13l1.14-.49a14.05,14.05,0,0,0,.4,1.58,1.33,1.33,0,0,0,2.05.67,1.39,1.39,0,0,1,.19-.15c2.12-1.62,4.45-3.07,6.82-4.63A57.49,57.49,0,0,1,178.36,150.17Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  x: 180.39,
  y: 125.69,
  width: 15.01,
  height: 39.13,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M193,135.8a18.45,18.45,0,0,0-10.8-9.67,14,14,0,0,0-1.78-.44,23.94,23.94,0,0,1,5.91,8.72c2.13,5.36,2.56,11.25,2.32,17-.13,3.3-.48,6.58-.83,9.87a13.39,13.39,0,0,0,3.4,3.52l.11-.17a50.79,50.79,0,0,0,3.93-14.32A27,27,0,0,0,193,135.8Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask-9",
  x: 164.64,
  y: 139.15,
  width: 4.63,
  height: 4.68,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M168.84,140a2.58,2.58,0,0,1,.33,2.17,5.1,5.1,0,0,1-.84,1.66,1.89,1.89,0,0,0-1.2-1,1.87,1.87,0,0,0-1.93.69,3.15,3.15,0,0,1-.47-2.52,2.64,2.64,0,0,1,1.76-1.82A2.24,2.24,0,0,1,168.84,140Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Fail2");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "cls-10"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M522.6,285.66c.13-7,58.51-55.9,4.44-121.69-20.06-24.42-55.45-24.36-65.14-40.92C446.43,96.61,448.2,64,427,40.34,400.26,10.48,340,.82,297.46,0c-36.18-.67-72.57,8.11-102.64,24.71C173.19,36.69,159.3,55.3,140.11,69.42,119,85,90.74,88.34,68.57,102.16,48.57,114.63,5,132.57.42,179.21c-4.31,43.73,25.67,88.22,54,104.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M547.83,292c0-15.59-122-28.23-272.57-28.23S2.7,276.45,2.7,292s122,28.23,272.56,28.23S547.83,307.63,547.83,292Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 350.76,
  y: 16.21,
  width: 150.31,
  height: 153.12
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 357.07,
  y: 22.64,
  width: 137.69,
  height: 140.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 422.7,
  y: 20.7,
  width: 6.43,
  height: 144.15
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 353.84,
  y: 89.56,
  width: 144.15,
  height: 6.43
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-15",
  points: "439.4 22.77 422.2 22.77 373.65 162.94 390.85 162.94 439.4 22.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-15",
  points: "457.72 22.71 447.39 22.77 398.84 162.94 409.17 162.87 457.72 22.71"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M441.29,259.25c-.69-5.22-2.1-53.17,11-48.64s4.26,41.26-7.18,49.8C444.35,261,441.44,260.39,441.29,259.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M443.09,261.12a.82.82,0,0,1-.31-.07.7.7,0,0,1-.33-.94c.07-.16,7.49-16.11,8.14-41.42a.69.69,0,0,1,.72-.69.71.71,0,0,1,.69.73c-.66,25.63-8.2,41.82-8.28,42A.69.69,0,0,1,443.09,261.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M440.52,258.54s9-8.73,2.43-15.34-4-13.09-3.74-16.36c.84-11-14.12-11.22-15.8,4.35S428.36,257.32,440.52,258.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M440.52,259.18a.66.66,0,0,1-.51-.25c-.11-.15-11-14.48-9.57-33.28a.65.65,0,0,1,.69-.59.63.63,0,0,1,.59.69c-1.37,18.31,9.2,32.26,9.31,32.39a.65.65,0,0,1-.12.9A.67.67,0,0,1,440.52,259.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M423.53,253.29v22a3.82,3.82,0,0,0,3.82,3.83H452a3.83,3.83,0,0,0,3.83-3.83v-22Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-19",
  x: 423.53,
  y: 253.29,
  width: 32.26,
  height: 5.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-20",
  x: 272.07,
  y: 195.28,
  width: 9.47,
  height: 83.83
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-20",
  x: 396.82,
  y: 195.28,
  width: 9.47,
  height: 83.83
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M417.79,193.76a5.92,5.92,0,0,1-5.92,5.91H266.49a5.92,5.92,0,0,1-5.92-5.91h0a5.92,5.92,0,0,1,5.92-5.92H411.87a5.92,5.92,0,0,1,5.92,5.92Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-18",
  x: 279.67,
  y: 181.89,
  width: 46.03,
  height: 6.09,
  rx: 1.89
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M321.45,187a1.72,1.72,0,0,1-1-2.25l14.4-36a1.73,1.73,0,0,1,2.25-1l2,.79a1.73,1.73,0,0,1,1,2.25l-14.4,36a1.73,1.73,0,0,1-2.26,1Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-21",
  x: 164.81,
  y: 189.51,
  width: 0.76,
  height: 45.25
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-21",
  x: 112.83,
  y: 233.08,
  width: 0.76,
  height: 45.25
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-21",
  x: 87.81,
  y: 185.63,
  width: 0.76,
  height: 45.25
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M186.53,158.91c-.06.66-.12,1.33-.17,2a9.3,9.3,0,0,1-1.27-.92,13.33,13.33,0,0,1-4.78-9.79,6.42,6.42,0,0,1-3.92-.68c-1.44-.62-3-1.35-4.5-1-.77.16-1.57.58-2.31.3a1.51,1.51,0,0,1-.85-1.68,1.9,1.9,0,0,1,1.4-1.35l0,.05a5.21,5.21,0,1,0-8.34-3.34,5,5,0,0,0,.9,2.19A10.33,10.33,0,0,1,149,138.38c1.7-.9,3.35-1.9,5-2.94,4.32-2.77,8.52-5.78,13.22-7.82s10.09-3,15-1.49A18.45,18.45,0,0,1,193,135.8a27,27,0,0,1,2.26,14.53,50.79,50.79,0,0,1-3.93,14.32l-.11.17A13.4,13.4,0,0,1,186.53,158.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M142.07,160.7l.05.05c-.09.65-.19,1.31-.3,2-2.34,1.28-4.63,2.66-6.84,4.17a201.64,201.64,0,0,0,5.11-25.18c.53-.1,1.06-.22,1.58-.36a61.69,61.69,0,0,1,.45,19.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M132.78,143.31h0a74.82,74.82,0,0,1-4.17,16.19,57.92,57.92,0,0,0-6.76-9.71,21.46,21.46,0,0,0-7.71-5.53A72.74,72.74,0,0,0,132.78,143.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M202.61,200.05c-5.75-.44-12.18-.9-18.5-1.36l0-.31c-.29-.7-.57-1.4-.86-2.11q-4.35-10.58-8.69-21.14l10.55-5.33,13.21,18.38a27.62,27.62,0,0,1,3.71,6.27A10.14,10.14,0,0,1,202.61,200.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M184.37,236.36,152.8,274.14c-5.44,6.51-10.92,13.07-17.55,18.35s-14.7,5.83-23.16,6.4H106c-11.85-.79-22.59-6.37-29-16.72-.3-.49-.6-1-.88-1.49h51.71c-.4-15.31.78-30.73,2.29-46.18l12.9-8.43,66-6.73c5.35,9.08,20.86,46.61,32,66.2L259,293a4.39,4.39,0,0,1,2.26.87,4,4,0,0,1,1.35,1.9c.46,1.36-1,3.09-2.56,3.09H229.87C223.52,290.05,198.24,254.92,184.37,236.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M180.55,163.44l4.58,6.36-10.55,5.33-2.46-6C174.72,167.17,177.63,165.45,180.55,163.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M230.6,222.86a.8.8,0,0,1,0,.51.55.55,0,0,1-.7.16,1.67,1.67,0,0,1-.56-.56l-2-2.79a15.75,15.75,0,0,1-.21,3.75,1.13,1.13,0,0,1-.39.77,1.1,1.1,0,0,1-.8.06,10.19,10.19,0,0,1-3-.9,4.62,4.62,0,0,1-2.18-2.16,4.9,4.9,0,0,1-.32-1.09,23.14,23.14,0,0,1-4.56-5.76,29.81,29.81,0,0,1,1.2,4.91,1.94,1.94,0,0,1-1.77-.35,5.14,5.14,0,0,1-1.18-1.44,23.34,23.34,0,0,1-2.15-4.58c-.07-.19-.13-.38-.19-.57a31.43,31.43,0,0,0,1.63-11.7l.66.17A117.34,117.34,0,0,1,227.56,211S229.9,218.89,230.6,222.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M207.71,200.42l4.29.33,1.45.37a31.43,31.43,0,0,1-1.63,11.7c-.06.18-.12.36-.19.54a27.06,27.06,0,0,1-2.7-.23A110.43,110.43,0,0,0,207.71,200.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M162.72,144.65a5,5,0,0,1-.9-2.19,5.21,5.21,0,1,1,8.34,3.34l0-.05a1.9,1.9,0,0,0-1.4,1.35,1.51,1.51,0,0,0,.85,1.68c.74.28,1.54-.14,2.31-.3,1.53-.32,3.06.41,4.5,1a6.42,6.42,0,0,0,3.92.68,13.33,13.33,0,0,0,4.78,9.79,53.52,53.52,0,0,1-4.54,3.46c-2.92,2-5.83,3.73-8.43,5.71l-.19.15a1.33,1.33,0,0,1-2.05-.67,14.05,14.05,0,0,1-.4-1.58c-.82.36-4.94,2.13-6.92,2.76-2.19.69-4.81.75-6.56-.74-1.57-1.34-2-3.53-2.44-5.55-.52-2.5-1.12-5-1.82-7.46l-9.62,4.61a61.69,61.69,0,0,0-.45-19.32,33.17,33.17,0,0,0,7.32-3,10.33,10.33,0,0,0,13.73,6.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M132.79,207.82c-.53,5.69-1.13,11.37-1.71,17.07a232.08,232.08,0,0,1-12.43-29.62,8.26,8.26,0,0,1-.35-1.27l1.29,1.27C123.93,199.51,128.28,203.77,132.79,207.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M140.09,141.71A201.64,201.64,0,0,1,135,166.89l-.55,2Q131.9,165,129.49,161c-.29-.49-.59-1-.88-1.48a74.82,74.82,0,0,0,4.17-16.19h0a69.49,69.49,0,0,0,7.32-1.72A.49.49,0,0,1,140.09,141.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M142.12,160.75c2.59,2.64,24.17,24.53,41.15,35.52.29.71.57,1.41.86,2.11l0,.31-28.75-2a253.6,253.6,0,0,1-20.93-27.78l.55-2c2.21-1.51,4.5-2.89,6.84-4.17C141.93,162.06,142,161.4,142.12,160.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M209,219.34l-66,6.73,11.39-7.44,50.41-4.21a38.08,38.08,0,0,1,3.12,3.37A14,14,0,0,1,209,219.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M121.78,245.08a5.49,5.49,0,0,1-.75,4.63,14.6,14.6,0,0,1-4.27,3.85c-2,1.36-4,2.7-6.13,3.89h0a10.94,10.94,0,0,1-5.21.07,7.24,7.24,0,0,1-4.33-3Q111.65,250.3,121.78,245.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M110.63,257.45c2.11-1.19,4.13-2.53,6.13-3.89a14.6,14.6,0,0,0,4.27-3.85,5.49,5.49,0,0,0,.75-4.63q-10.11,5.22-20.69,9.45a7.24,7.24,0,0,0,4.33,3,10.94,10.94,0,0,0,5.21-.07Zm94.18-43-50.41,4.21-3.35.28a10.47,10.47,0,0,1-7.28-2.15c-3.24-2.51-8.13-6.38-11-8.94-4.51-4-8.86-8.31-13.2-12.55L118.3,194a8.26,8.26,0,0,0,.35,1.27,232.08,232.08,0,0,0,12.43,29.62c-.33,3.2-.66,6.4-1,9.61-1.51,15.45-2.69,30.87-2.29,46.18H68.91c-6-26.63-4.67-54.66,1.63-81.24,2.81-11.83,6.66-23.58,13.29-33.76,6-9.26,15.9-20.94,27.11-22.31a14.09,14.09,0,0,1,3.2.9,21.46,21.46,0,0,1,7.71,5.53,57.92,57.92,0,0,1,6.76,9.71c.29.5.59,1,.88,1.48q2.4,4,4.94,7.89a253.6,253.6,0,0,0,20.93,27.78l28.75,2c6.32.46,12.75.92,18.5,1.36l5.1.37a110.43,110.43,0,0,1,1.22,12.71c0,.32,0,.63,0,1Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-30"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M216,209.73c-.93-1-1.73-2.14-2.71-3.09a30.6,30.6,0,0,1-1.42,6.18c.06.19.12.38.19.57a23.34,23.34,0,0,0,2.15,4.58,5.14,5.14,0,0,0,1.18,1.44,1.94,1.94,0,0,0,1.77.35,29.81,29.81,0,0,0-1.2-4.91,23.14,23.14,0,0,0,4.56,5.76,4.9,4.9,0,0,0,.32,1.09,4.62,4.62,0,0,0,2.18,2.16,10.19,10.19,0,0,0,3,.9,1.1,1.1,0,0,0,.8-.06,1.13,1.13,0,0,0,.39-.77,14.67,14.67,0,0,0,.22-3.31,46.67,46.67,0,0,0-2.8-6.6A13.77,13.77,0,0,1,216,209.73Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-32"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M142.07,160.7l.05.05c-.09.65-.19,1.31-.3,2-2.34,1.28-4.63,2.66-6.84,4.17a201.64,201.64,0,0,0,5.11-25.18c.53-.1,1.06-.22,1.58-.36a61.69,61.69,0,0,1,.45,19.32Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M202.61,200.05c-5.75-.44-12.18-.9-18.5-1.36l0-.31c-.29-.7-.57-1.4-.86-2.11q-4.35-10.58-8.69-21.14l10.55-5.33,13.21,18.38a27.62,27.62,0,0,1,3.71,6.27A10.14,10.14,0,0,1,202.61,200.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M180.55,163.44l4.58,6.36-10.55,5.33-2.46-6C174.72,167.17,177.63,165.45,180.55,163.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M207.71,200.42l4.29.33,1.45.37a31.43,31.43,0,0,1-1.63,11.7c-.06.18-.12.36-.19.54a27.06,27.06,0,0,1-2.7-.23A110.43,110.43,0,0,0,207.71,200.42Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-33"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M132.79,207.82c-.53,5.69-1.13,11.37-1.71,17.07a232.08,232.08,0,0,1-12.43-29.62,8.26,8.26,0,0,1-.35-1.27l1.29,1.27C123.93,199.51,128.28,203.77,132.79,207.82Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M140.09,141.71A201.64,201.64,0,0,1,135,166.89l-.55,2Q131.9,165,129.49,161c-.29-.49-.59-1-.88-1.48a74.82,74.82,0,0,0,4.17-16.19h0a69.49,69.49,0,0,0,7.32-1.72A.49.49,0,0,1,140.09,141.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M142.12,160.75c2.59,2.64,24.17,24.53,41.15,35.52.29.71.57,1.41.86,2.11l0,.31-28.75-2a253.6,253.6,0,0,1-20.93-27.78l.55-2c2.21-1.51,4.5-2.89,6.84-4.17C141.93,162.06,142,161.4,142.12,160.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M209,219.34l-66,6.73,11.39-7.44,50.41-4.21a38.08,38.08,0,0,1,3.12,3.37A14,14,0,0,1,209,219.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M121.78,245.08a5.49,5.49,0,0,1-.75,4.63,14.6,14.6,0,0,1-4.27,3.85c-2,1.36-4,2.7-6.13,3.89h0a10.94,10.94,0,0,1-5.21.07,7.24,7.24,0,0,1-4.33-3Q111.65,250.3,121.78,245.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M121.38,245.28l.56.37a4,4,0,0,0-.16-.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M101.09,254.53a7.24,7.24,0,0,0,4.33,3,10.94,10.94,0,0,0,5.21-.07h0c2.11-1.19,4.13-2.53,6.13-3.89a14.6,14.6,0,0,0,4.27-3.85,5.73,5.73,0,0,0,.91-4.06l-.56-.37Q111.45,250.38,101.09,254.53Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-37"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M118.3,194,96.78,172.68s-3.52,53.4,24.6,72.6l.4-.2a4,4,0,0,1,.16.57,36.93,36.93,0,0,0,6.88,3.56c.37-4.9.81-9.8,1.29-14.71.31-3.21.64-6.41,1-9.61-1.27-2.52-2.5-5.07-3.67-7.64h0a231.18,231.18,0,0,1-8.76-22A8.26,8.26,0,0,1,118.3,194Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-38"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M76.11,280.68c.28.5.58,1,.88,1.49a34.17,34.17,0,0,0,12.09,11.74A90.34,90.34,0,0,0,119,280.68Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-39"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-40",
  d: "M185.09,160a13.33,13.33,0,0,1-4.78-9.79,4.29,4.29,0,0,1-1.95,0,57.49,57.49,0,0,0,.58,14.35l1.61-1.08A53.52,53.52,0,0,0,185.09,160Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M172.62,148.41a3.61,3.61,0,0,0-.73.07c-.77.16-1.57.58-2.31.3a1.51,1.51,0,0,1-.85-1.68,1.9,1.9,0,0,1,1.4-1.35l0,.05a5.21,5.21,0,1,0-8.34-3.34,5,5,0,0,0,.9,2.19A10.33,10.33,0,0,1,149,138.38a33.17,33.17,0,0,1-7.32,3,61.69,61.69,0,0,1,.45,19.32l9.62-4.61c.7,2.47,1.3,5,1.82,7.46.42,2,.87,4.21,2.44,5.55,1.75,1.49,4.37,1.43,6.56.74,1.49-.47,4.18-1.59,5.78-2.27A46,46,0,0,1,172.62,148.41Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-41"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M178.36,150.17a10.14,10.14,0,0,1-2-.66,9.78,9.78,0,0,0-3.77-1.1,46,46,0,0,0-4.28,19.13l1.14-.49a14.05,14.05,0,0,0,.4,1.58,1.33,1.33,0,0,0,2.05.67,1.39,1.39,0,0,1,.19-.15c2.12-1.62,4.45-3.07,6.82-4.63A57.49,57.49,0,0,1,178.36,150.17Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-43"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M193,135.8a18.45,18.45,0,0,0-10.8-9.67,14,14,0,0,0-1.78-.44,23.94,23.94,0,0,1,5.91,8.72c2.13,5.36,2.56,11.25,2.32,17-.13,3.3-.48,6.58-.83,9.87a13.39,13.39,0,0,0,3.4,3.52l.11-.17a50.79,50.79,0,0,0,3.93-14.32A27,27,0,0,0,193,135.8Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-45"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M168.84,140a2.58,2.58,0,0,1,.33,2.17,5.1,5.1,0,0,1-.84,1.66,1.89,1.89,0,0,0-1.2-1,1.87,1.87,0,0,0-1.93.69,3.15,3.15,0,0,1-.47-2.52,2.64,2.64,0,0,1,1.76-1.82A2.24,2.24,0,0,1,168.84,140Z"
})))));

var SvgLostNoSatisfaction = function SvgLostNoSatisfaction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 550 320.27",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLostNoSatisfaction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lost_no_satisfaction.57a1a451.svg";
export { ForwardRef as ReactComponent };